import React from 'react';
import { Route, IndexRoute } from 'react-router';
import StatementBuyPoints from './buyActions';

export default (
  <Route path="buy-actions-transactions">
    <IndexRoute component={(props) => <StatementBuyPoints {...props} />} />
  </Route>
);
